<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Contact US" bg="/images/form/contact/visual.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <p class="page-text text-right mb-16 mb-lg-20"><span class="red--text">*</span> 필수입력 항목입니다.</p>
            <v-sheet class="form-table">
                <v-row align="center">
                    <v-col cols="12" md="auto" class="font-size-18 font-weight-medium">
                        <v-card flat width="116">회사명 <span class="red--text">*</span></v-card>
                    </v-col>
                    <v-col cols="12" md="">
                        <v-text-field v-model="form.companyName" outlined hide-details="auto" placeholder="회사명을 입력하세요."></v-text-field>
                    </v-col>
                </v-row>
                <v-divider class="my-12" />
                <v-row align="center">
                    <v-col cols="12" md="auto" class="font-size-18 font-weight-medium">
                        <v-card flat width="116">담당자명 <span class="red--text">*</span></v-card>
                    </v-col>
                    <v-col cols="12" md="">
                        <v-text-field v-model="form.manager" outlined hide-details="auto" placeholder="담당자명을 입력하세요."></v-text-field>
                    </v-col>
                </v-row>
                <v-divider class="my-12" />
                <v-row align="center">
                    <v-col cols="12" md="auto" class="font-size-18 font-weight-medium">
                        <v-card flat width="116">연락처 <span class="red--text">*</span></v-card>
                    </v-col>
                    <v-col cols="12" md="">
                        <v-text-field v-model="form.phone" outlined hide-details="auto" placeholder="연락받으실 연락처를 입력하세요."></v-text-field>
                    </v-col>
                </v-row>
                <v-divider class="my-12" />
                <v-row align="center">
                    <v-col cols="12" md="auto" class="font-size-18 font-weight-medium">
                        <v-card flat width="116">이메일 <span class="red--text">*</span></v-card>
                    </v-col>
                    <v-col cols="12" md="">
                        <v-row class="row--small">
                            <v-col cols="6">
                                <v-text-field v-model="email1" outlined hide-details="auto" placeholder="이메일을 입력하세요."></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-combobox v-model="email2" outlined hide-details="auto" prefix="@" :items="emailItems"/>
                                <!-- <v-select v-model="email2" outlined hide-details="auto" label="@" :items="emailItems" item-text="text" item-value="value"></v-select> -->
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-divider class="my-12" />
                <v-row align="center">
                    <v-col cols="12" md="auto" class="font-size-18 font-weight-medium">
                        <v-card flat width="116">내용 <span class="red--text">*</span></v-card>
                    </v-col>
                    <v-col cols="12" md="">
                        <v-textarea v-model="form.content" height="334" outlined hide-details="auto" placeholder="내용을 입력하세요"></v-textarea>
                    </v-col>
                </v-row>
                <v-divider class="my-12" />
            </v-sheet>

            <div class="btn-wrap">
                <v-row justify="center" class="row--small">
                    <v-col cols="auto" @click="$rotuer.push('/ko')"><v-btn large outlined color="grey" min-width="200">취소</v-btn></v-col>
                    <v-col cols="auto" @click="save"><v-btn large color="primary" min-width="200">작성완료</v-btn></v-col>
                </v-row>
            </div>
        </sub-section>
    </client-page>
</template>

<script>
import api from "@/api";

import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
    },
    data() {
        return {
            form: {
                companyName: null,
                manager: null,
                phone: null,
                email: null,
                locale: "ko",
                code: "contact",
                content: null,
            },
            emailItems: ["gmail.com", "naver.com"],
            email1: null,
            email2: null
        }
    },
    methods: {
        validate() {
            try {
                if (!this.form.companyName) throw new Error("회사명을 입력해주세요");
                if (!this.form.manager) throw new Error("담당자명을 입력해주세요");
                if (!this.form.phone) throw new Error("핸드폰번호를 입력해주세요");
                if (!this.form.email) throw new Error("이메일을 입력해주세요");
                if (!this.form.content) throw new Error("내용을 입력해주세요");
                return true;
            } catch (error) {
                alert(error.message)
                return false;
            }
        },
        async save() {
            if (this.validate()) {
                await api.v1.forms.post(this.form);
                alert("폼메일이 신청되었습니다.");
                this.$router.push("/ko")
            }
        }
    },
    watch: {
        "email1"() {
            this.email1 && this.email2 ? this.form.email = `${this.email1}@${this.email2}` : null
        },
        "email2"() {
            this.email1 && this.email2 ? this.form.email = `${this.email1}@${this.email2}` : null
        }
    }
};
</script>

<style lang="scss" scoped>
.form-table {
    border-top: 2px solid #111;
    padding-top: 12px;
}
.btn-wrap {
    margin-top: 40px;
}
@media (min-width: 1024px) {
    .btn-wrap {
        margin-top: 60px;
    }
}
</style>